import React from 'react';
import {
  Grid,
  Typography,
  Button,
  makeStyles,
} from '@material-ui/core';
import { CalendarToday, AccountBalance } from '@material-ui/icons';

const useStyle = makeStyles((theme) => ({
  recallTitle: {
    fontSize: 24,
    //fontColor: "rgb(10,132,255)",//theme.palette.branding.main,
    fontColor: "black",
    [theme.breakpoints.only('sm')]: {
      fontSize: 24,
    },
    [theme.breakpoints.only('md')]: {
      fontSize: 28,
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: 32,
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: 36,
    },
  },
  breakingNews: {
    fontSize: 24,
    fontColor: "black",
  },
  sectionsSpace: {
    [theme.breakpoints.only('xs')]: {
      marginBottom: 25,
    },
    [theme.breakpoints.only('sm')]: {
      marginBottom: 30,
    },
    [theme.breakpoints.only('md')]: {
      marginBottom: 60,
    },
    [theme.breakpoints.only('lg')]: {
      marginBottom: 20,
    },
    [theme.breakpoints.only('xl')]: {
      marginBottom: 30,
    },
  },
  contentSpace: {
    marginBottom: 10,
    [theme.breakpoints.only('md')]: {
      marginBottom: 15,
    },
    [theme.breakpoints.only('lg')]: {
      marginBottom: 7,
    },
  },
  headerLinkBlack: {
    textDecoration: 'none',
    color: "black"
    // color: "rgb(10,132,255)",
    //marginLeft: 18,
  },
  headerLink: {
    textDecoration: 'none',
    color: "rgb(10,132,255)",
    //marginLeft: 18,
  },
  headerLinkPrimary: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    //marginLeft: 18,
  },
  breakingNewsLink: {
    textDecoration: 'underline',
    color: "red",
    //marginLeft: 18,
  },
  link: {
    textDecoration: 'none',
    color: '#000',
  },
  center: {
    textAlign: "center",
  },
  customButton: {
    color: "grey", // Replace with a specific grey shade if needed, e.g., '#757575'
  },
}));

const DialogInformation = (props) => {
  const { recall } = props;
  const classes = useStyle();

  return (
    <Grid container>
      <Grid container className={classes.sectionsSpace}>
        <Grid item xs={12} className={classes.contentSpace}>
          <a
            href={recall.getRecallURL()}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.headerLink}
          >
            <Typography
              variant="h2"
              // color="initial"
              className={classes.recallTitle}
            >
              {recall.headline}
            </Typography>
          </a>
        </Grid>
        <Grid item xs={6} className={classes.contentSpace}>
        <Grid container justify="flex-start">
        {/* <ButtonGroup> */}
          <a
          href={recall.getAgencyURL()}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
          >
            <Button
              size="large"
              variant="text"
              disabled
              startIcon={<AccountBalance />}
              className={classes.customButton}
            >
              {recall.getAgency()}
            </Button>
          </a>
          {/* </ButtonGroup> */}
        </Grid>
        </Grid>
        <Grid item xs={6}  className={classes.contentSpace}>
        <Grid container justify="flex-end">
          {/* <ButtonGroup> */}
            <Button
              size="large"
              variant="text"
              disabled
              startIcon={<CalendarToday />}
              className={classes.customButton}
            >
              {!recall.isAnnouncement() ? recall.getDateString() : recall.getAlertType()}
            </Button>
          {/* </ButtonGroup> */}
        </Grid>
        </Grid>
        { recall.hasBreakingNews() ?
        <Grid item xs={12} className={`${classes.contentSpace} ${classes.center}`}>
          <a
            href={recall.getBreakingNewsSource()}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.breakingNewsLink}
          >
            <Typography
              variant="h4"
              className={classes.breakingNews}
            >
              {recall.getBreakingNews(true)}
            </Typography>
          </a>
        </Grid>
        :
          <Grid item xs={12} className={`${classes.contentSpace} ${classes.center}`}>
            <Typography
              variant="h4"
              className={classes.breakingNews}
            >
             {recall.getRecallReasonDescription(true)}
            </Typography>
          </Grid>
      }
      </Grid>
    </Grid>
  );
};

export default DialogInformation;
